<template>
  <v-card flat tile outlined :loading="!chart">
    <v-toolbar flat>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" :md="noPie ? 12 : 8">
          <ChartTable :label="label" :data="rows" />
        </v-col>
        <v-col v-if="!noPie" class="text-center">
          <pie-chart
            v-if="chart"
            :messages="{ empty: 'Non ci sono dati' }"
            :data="pieData"
            :library="library"
            width="240px"
          ></pie-chart>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions v-if="!noInterval">
      <v-btn-toggle v-model="interval" mandatory tile group>
        <v-btn value="3" small>
          3 mesi
        </v-btn>
        <v-btn value="6" small>
          6 mesi
        </v-btn>
        <v-btn value="12" small>
          12 mesi
        </v-btn>
      </v-btn-toggle>
    </v-card-actions>
  </v-card>
</template>

<script>
import dashboard from '@mixins/dashboard.js'
import ChartTable from '@components/dashboard/ChartTable.vue'

/** Card generica: tabella (+ torta) di un report `dashboard/report?type=<scope>` con selettore periodo */
export default {
  name: 'ReportCard',
  components: { ChartTable },
  mixins: [dashboard],
  props: {
    title: { type: String, required: true },
    scope: { type: String, required: true },
    label: { type: String, default: 'Voce' },
    noPie: { type: Boolean, default: false },
    noInterval: { type: Boolean, default: false },
  },
  data: () => ({
    resource: 'report',
    interval: '12',
    library: {
      layout: { padding: { left: 16, right: 16, top: 0, bottom: 16 } },
      legend: { display: false, position: 'bottom' },
    },
  }),
  computed: {
    rows() {
      return this.dashboardData(this.resource, this.scope) || []
    },
    pieData() {
      return this.rows.map((r) => [r.label, r.count])
    },
  },
  watch: {
    interval: {
      immediate: true,
      handler: 'getData',
    },
  },
  methods: {
    getData() {
      this.getReportData({
        resource: this.resource,
        scope: this.scope,
        interval: this.interval,
      })
    },
  },
}
</script>
